import { IRecommendedPackage } from '../../../../../../../../types/reducers/recommendedPackages';

interface ITrackingData {
  id: number;
  cnt: number;
  name: string;
  price: number;
  discount: number;
}

export const mapPackageTrackingData = (recommendedPackage: IRecommendedPackage): ITrackingData => ({
  id: recommendedPackage.packageId,
  cnt: recommendedPackage.totalAnnouncementsCount,
  name: recommendedPackage.headerText,
  price: recommendedPackage.price,
  discount: recommendedPackage.discountPercent,
});
